import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function usePlpRedirectUrlNavigation({
  redirectUrl,
  sidFromUrl,
}: {
  redirectUrl: string | null;
  sidFromUrl?: string;
}) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!redirectUrl) return;
    // Do not navigate if we are already on the redirect target (avoids infinite loop).
    const redirectPath = redirectUrl.split('?')[0];
    if (redirectPath === location.pathname) return;

    if (!sidFromUrl) {
      navigate(redirectUrl, { replace: true });
      return;
    }

    try {
      const nextUrl = new URL(redirectUrl, window.location.origin);
      if (!nextUrl.searchParams.get('sid')) {
        nextUrl.searchParams.set('sid', sidFromUrl);
      }

      const nextPath = `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
      navigate(nextPath, { replace: true });
    } catch {
      navigate(redirectUrl, { replace: true });
    }
  }, [redirectUrl, sidFromUrl, navigate, location.pathname]);
}

